import { render, staticRenderFns } from "./FlagMap.vue?vue&type=template&id=331c5a63&"
import script from "./FlagMap.vue?vue&type=script&lang=js&"
export * from "./FlagMap.vue?vue&type=script&lang=js&"
import style0 from "./FlagMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContent,VIcon})
